module.exports = __webpack_public_path__ + "static/media/resolvePerson.b97006d4.png";